<template>
  <div class="mb-1" style="font-size: 12px">
    Protected by reCAPTCHA, Google
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a href="https://policies.google.com/terms">Terms of Service</a>
    apply.<br />
  </div>
</template>
